// extracted by mini-css-extract-plugin
export default {"skill":"Skill_skill__vghba","logo":"Skill_logo__o8WP0","name":"Skill_name__FXI2A"};